export default {"src":"/_next/static/media/discord.a1d8c0a6.svg","height":10,"width":13};